var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import { StackChildren, InlineChildren, Text, Icon, Inset, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import BudgetStrings from '../BudgetStrings';
import { useSendBudgetReminderMutation } from '../useSendBudgetReminderMutation';
import { useToast } from '@doordash/component-toast';
import track from '../../../utils/track';
import { MealBudgetsEvents } from '../../../constants/events';
import { SendBudgetReminderErrorCode } from '../../../types/GloblalTypes';
var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 300px;\n"], ["\n  max-width: 300px;\n"])));
var EmailSendingFailedErrorContent = function (_a) {
    var errorMessage = _a.errorMessage, handleOnClose = _a.handleOnClose;
    return (React.createElement(StackChildren, { size: StackChildren.Sizes.Medium },
        React.createElement(Text, { color: Text.Colors.TextSecondary }, errorMessage),
        React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: handleOnClose }, BudgetStrings.sendEmailNotificationsModalErrorAcknowledgedButton())))));
};
var ConfirmSendingEmailContent = function (_a) {
    var isGroupRestrictedBudget = _a.isGroupRestrictedBudget, teamAccountName = _a.teamAccountName, handleOnClose = _a.handleOnClose, handleConfirmSend = _a.handleConfirmSend;
    return (React.createElement(StackChildren, { size: StackChildren.Sizes.Medium },
        React.createElement(Text, { color: Text.Colors.TextSecondary }, isGroupRestrictedBudget
            ? BudgetStrings.sendEmailNotificationsModalDescriptionForGroupRestrictedBudget()
            : BudgetStrings.sendEmailNotificationsModalDescription(teamAccountName)),
        React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
            React.createElement(ButtonGroupContainer, null,
                React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                    React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: handleOnClose }, BudgetStrings.sendEmailNotificationsModalCancelButtonText()),
                    React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: handleConfirmSend }, BudgetStrings.sendEmailNotificationsModalSendButtonText()))))));
};
export var SendEmailNotificationsModal = function (_a) {
    var onClose = _a.onClose, teamAccountName = _a.teamAccountName, budgetInfo = _a.budgetInfo, entryPoint = _a.entryPoint;
    var displayToast = useToast().displayToast;
    var _b = __read(React.useState(BudgetStrings.sendEmailNotificationsModalTitle()), 2), modalTitle = _b[0], setModalTitle = _b[1];
    var _c = __read(React.useState(''), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var sendBudgetEmailNotifications = useSendBudgetReminderMutation().sendBudgetEmailNotifications;
    var budgetId = budgetInfo.id;
    var isGroupRestrictedBudget = budgetInfo.hasGroup;
    var setErrorModalContent = function (errorCode) {
        if (errorCode === SendBudgetReminderErrorCode.BUDGET_EXPIRED) {
            setModalTitle(BudgetStrings.sendEmailNotificationsModalErrorTitleBudgetExpired());
            setErrorMessage(BudgetStrings.sendEmailNotificationsModalErrorDescriptionBudgetExpired());
        }
        else {
            setModalTitle(BudgetStrings.sendEmailNotificationsModalErrorTitleGeneric());
            setErrorMessage(BudgetStrings.sendEmailNotificationsModalErrorDescriptionGeneric());
        }
    };
    var handleConfirmSend = function () {
        sendBudgetEmailNotifications(budgetId, {
            onCompleted: function (response) {
                var _a;
                if ((_a = response === null || response === void 0 ? void 0 : response.sendBudgetReminder) === null || _a === void 0 ? void 0 : _a.error) {
                    setErrorModalContent(response.sendBudgetReminder.error.errorCode);
                    return;
                }
                onClose();
                track(MealBudgetsEvents.BUDGET_CREATION_REMINDER, {
                    budgetId: budgetId,
                    entryPoint: entryPoint,
                });
                displayToast({
                    icon: Icon.Types.Check,
                    text: BudgetStrings.sendEmailNotificationsModalSuccessToast(),
                    insetFromEdge: Inset.Sizes.XxxLarge,
                });
            },
        });
    };
    var handleOnClose = function () {
        onClose();
        track(MealBudgetsEvents.BUDGET_CREATION_REMINDER_CANCELLED, {
            budgetId: budgetId,
        });
    };
    React.useEffect(function () {
        track(MealBudgetsEvents.BUDGET_REMINDER_MODAL_VIEWED, {
            budgetId: budgetId,
        });
    }, [budgetId]);
    return (React.createElement(Modal, { onClose: handleOnClose, title: modalTitle }, !!errorMessage ? (React.createElement(EmailSendingFailedErrorContent, { errorMessage: errorMessage, handleOnClose: handleOnClose })) : (React.createElement(ConfirmSendingEmailContent, { isGroupRestrictedBudget: isGroupRestrictedBudget, teamAccountName: teamAccountName, handleOnClose: handleOnClose, handleConfirmSend: handleConfirmSend }))));
};
export default SendEmailNotificationsModal;
var templateObject_1;
